import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import { Icon, Row, Col } from "antd";
import MenuPortal from "../Portal/MenuPortal";
//Imagenes
import Obs8 from "../../../assets/img/Portal/acreditacion.png";



const Acreditacion = () => {
  function toTop() {
    window.scrollTo(0, 0);
}

  useEffect(() => {
    toTop();
  }, []);
  
  return (
    <div className="interioresPortal new-design">
      <Row  gutter={24}>
      <Col xxl={{ span: 3 }} xl={{ span: 3  }}>
      <Link to={"/"} className="button-back">
        <Icon type="play-circle" theme="filled" rotate="180" /> Regresar
      </Link>
      </Col>
    
      <Col xxl={{ span: 21}} xl={{ span: 21}}>
      <MenuPortal active={'acreditacion'}/></Col>
      </Row>

      <h1 className="main-title">Proceso de acreditación</h1>
      
      <Row  gutter={24} className="interioresPortal new-design descript-text" >
        <Col xxl={{ span: 18, offset: 3 }} xl={{ span: 18, offset: 3 }} lg={{ span: 18, offset: 3 }} md={{ span: 18, offset: 3 }} sm={24} xs={24}>
          <p>
          Todo el proceso de acreditación podrás llevarlo mediante el Portal de Observadoras y Observadores Electorales, para ello deberás realizar lo siguiente:
          </p>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={24}>
          <img src={Obs8} className="img-principal img-center" alt=""/>
        </Col>
      </Row>    
      
    
    </div>
  );
};

export default Acreditacion;
